// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PRICE_CURRENCY_int = "%(int)s \u20ac";
export const PRICE_CURRENCY_int__float = "%(int)s,%(float)s \u20ac";
export const PRICE_FORFREE = "Darujem";
